export default {
  templateItemsByLang: (state) => (language) => {
    return state.template.items.filter((i) => i.language === language);
  }
};
